import React, {useCallback, useEffect, useRef, useState} from "react";
import {fetchPublicGlobalSettings} from "../http/bookAPI";
import CacheUpdateNotice from "./CacheUpdateNotice";

const STORAGE_KEY = "virtalibry_spa_seen_version";
const POLL_MS = 5 * 60 * 1000;
const DEFAULT_MESSAGE =
    "Virtalibry has just been updated. Refresh this page to continue with the latest version.";

const GlobalSpaUpdateNotice = () => {
    const [notice, setNotice] = useState(null);
    const mountedRef = useRef(false);

    const applyNotice = useCallback((data) => {
        const incoming = data?.spa_update_notice;
        const version = String(incoming?.version || "").trim();

        if (!incoming?.active || !version) {
            setNotice(null);
            return;
        }

        const seenVersion = localStorage.getItem(STORAGE_KEY);
        if (seenVersion === version) {
            setNotice(null);
            return;
        }

        const mode = incoming.mode || "modal";
        if (mode === "green_line") {
            localStorage.setItem(STORAGE_KEY, version);
        }

        setNotice({
            version,
            mode,
            message: incoming.message || DEFAULT_MESSAGE,
        });
    }, []);

    const loadNotice = useCallback(async () => {
        try {
            const data = await fetchPublicGlobalSettings();
            if (mountedRef.current) applyNotice(data);
        } catch {
            if (mountedRef.current) setNotice(null);
        }
    }, [applyNotice]);

    useEffect(() => {
        mountedRef.current = true;
        loadNotice();
        const intervalId = setInterval(loadNotice, POLL_MS);

        return () => {
            mountedRef.current = false;
            clearInterval(intervalId);
        };
    }, [loadNotice]);

    const handleRefresh = () => {
        if (notice?.version) {
            localStorage.setItem(STORAGE_KEY, notice.version);
        }
        window.location.reload();
    };

    if (!notice) return null;

    return (
        <CacheUpdateNotice
            mode={notice.mode}
            message={notice.message}
            version={notice.version}
            onRefresh={handleRefresh}
        />
    );
};

export default GlobalSpaUpdateNotice;
